module.exports = {
	"pathContext": {
		"path": "/shop/merino-classic-scarf/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shop-merino-classic-scarf.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/shop-merino-classic-scarf.json
// module chunks = 2845203110960